import {
    ApiParameter,
    del,
    get,
    HasPagingParameters,
    patch,
    post,
    request,
} from "@insite/client-framework/Services/ApiService";

import {
    cancelSubscribedProductsList,
    getSubscribedProducts,
    getSubscribedProductsModel,
    getSubscriptionActiveModel,
    products,
    SubscriptionProductIsSelected,
    SubscriptionProductServiceCollectionModel,
    updateSubscriptionCollectionModel,
} from "@TKCCP/Types/ApiModels";

const subscriptionProductsUrl = `/api/v1/SubscriptionService/GetSubscriptionProductsList`;
const subscriptionSendProductUrl = "/api/v1/SubscriptionService/CreateSubscriptionAndProduct";
const getSubscriptionProductsUrl = "/api/v1/SubscriptionService/GetSubscriptionDetails";
const cancelSubscriptionUrl = "/api/v1/SubscriptionService/CancelSubscription";
const updateSubscriptionUrl = "/api/v1/SubscriptionService/UpdateSubscriptionAndProduct";
const getActiveSubscriptionServiceUrl = "/api/v1/SubscriptionService/GetActiveSubscription";

export interface GetSubscriptionProductApiParameter {
    SubscriptionId: string;
    customerBillToId: string;
}

export interface CancelSubscriptionListApiParameter extends ApiParameter {
    SubscriptionIdList: string[];
}

export interface subscriptionSendApiParameter {
    Name: string;
    UserProfileId: string;
    CustomerId: string;
    StartDate: string;
    EndDate: string | null;
    IsActive: boolean;
    NextOrderFrequencyInDays: string;
    CustomerPO: string;
    CustomerVatNumber: string;
    SubscriptionProductsList: SubscriptionProductIsSelected[];
}

export interface subscriptionUpdateApiParameter {
    Id: string;
    Name: string;
    UserProfileId: string;
    CustomerId: string;
    StartDate: string;
    EndDate: string | null;
    IsActive: boolean;
    NextOrderFrequencyInDays: string;
    SubscriptionProductsList: SubscriptionProductIsSelected[];
}
export interface mySubscriptionProducts extends ApiParameter, HasPagingParameters {
    UserProfileId: string | "";
    CustomerId: string | "";
}

export async function getSubscriptionProducts(
    parameter: GetSubscriptionProductApiParameter,
): Promise<SubscriptionProductServiceCollectionModel> {
    const url = `${subscriptionProductsUrl}/?SubscriptionId=${parameter.SubscriptionId}&CustomerBilltoId=${parameter.customerBillToId}`;
    const list = await get<SubscriptionProductServiceCollectionModel>(`${url}`);
    return list;
}

export async function mySubscribedProducts(parameter: mySubscriptionProducts): Promise<getSubscribedProducts> {
    try{
        const url = `${getSubscriptionProductsUrl}/?UserProfileId=${parameter.UserProfileId}&CustomerId=${parameter.CustomerId}`;
        const list = await get<getSubscribedProducts>(`${url}`);
        return list;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
}

export async function getSubscriptionActive(parameter: mySubscriptionProducts): Promise<getSubscriptionActiveModel>{
    const urlGetSubscriptionActive = `${getActiveSubscriptionServiceUrl}/?UserProfileId=${parameter.UserProfileId}&CustomerId=${parameter.CustomerId}`;
    const responseData = await get<getSubscriptionActiveModel>(`${urlGetSubscriptionActive}`);
    return responseData;
}

export function sendSubscriptionDetails(parameter: subscriptionSendApiParameter) {
    return post<subscriptionSendApiParameter, void>(`${subscriptionSendProductUrl}`, parameter);
}

export function updateSubscriptionDetails(parameter: subscriptionUpdateApiParameter) {
    return patch<updateSubscriptionCollectionModel>(`${updateSubscriptionUrl}`, parameter);
}

export async function cancelSubscription(parameter: CancelSubscriptionListApiParameter) {
    const sendData = {
        SubscriptionIdList: parameter.SubscriptionIdList,
    };
    const list = await patch<SubscriptionProductServiceCollectionModel>(`${cancelSubscriptionUrl}`, sendData);
    return list;
}
